<!-- HEADER CONTENEDOR -->
<app-loading-searcher *ngIf="datesCompany === undefined"></app-loading-searcher>

<app-header-core *ngIf="datesCompany != undefined" [dataCompany]="datesCompany"></app-header-core>

<span class="ir-arriba" [ngStyle]="{'background': colorPrimario}">&#9650;</span>

<!--<div class="container" [ngStyle]="{ 'background-color': colorPrimario }">-->
<div class="container search" style="background-color: #ccc">
    <!-- BARRA BUSQUEDA CONTENEDOR -->
    <app-search *ngIf="datesCompany != undefined" [dataCompany]="datesCompany" [childExample]="datesCompany.code" [colorMain]="datesCompany.mainColor" (valuesChange)="recibirDatos($event)" (resetValueContentResult)="ocultarContendorResultados($event)" [listYearMonth]="datesCompany.listYearMonth"
        [catalogueItinerary]="datesCompany.listDays" [cataloguePax]="datesCompany.listPassenger" [colorSecundario]="colorSecundario" [isSearching]="isSearching" (resetShowLoading)="showLoading($event)"
        (isPromoOnly)="setIsPromoOnly($event)">
    </app-search>
    <!-- FIN BARRA BUSQUEDA CONTENEDOR -->
</div>
<!-- FIN HEADER CONTENEDOR -->
<!-- BODY CONTENEDOR -->
<div class="container ecomm-bck">
    <div class="wrap2" style="overflow:visible">
        <!-- START LOADING COMPONENT -->
        <app-loading-results *ngIf="mostrarLoading"></app-loading-results>
        <!-- END LOADING COMPONENT  -->


        <!-- SECCION DE CARGA DE DATOS -->


        <div id="contenedorResultados" *ngIf="mostrarContenedorResultados">
            <a onclick="window.print() " (click)="this.addLogPrintResults()" class="print"><img src="assets/images/pdf.png" width="35" height="50" alt="Print this page" title="Print this page" /></a>
            <img src="{{companyLogo}}{{ datesCompany.logo }}" height="66" alt="" class="print" />
            <h1 *ngIf="cruiseService.getCruisesList().length===1">Cruise Availability for {{cruiseService.getCruisesList()[0].nameBoat }}, {{ dateRange }} </h1>
            <h1 *ngIf="cruiseService.getCruisesList().length!==1">Cruise Availability for {{ dateRange }} </h1>
            <p>{{this.companyService?.getLabelSlogan()}} <a [href]="mailTo">{{companyService?.getLabelSloganContactUs()}}</a> </p>
            <div class="row-powered-by-container">

                <p class="desc">Showing {{ totalSearch }} tour options:</p>
                <p style="background-color: #f5f5f5; max-width: 155px;" *ngIf="companyService.getOptionHeaderStyle()== optionEnum.ROYAL"> </p>
                <img src="assets/images/powered-by-galavail.svg" alt="powered-by" />
                <p style="background-color: #f5f5f5; max-width: 155px;" *ngIf="companyService.getOptionHeaderStyle()== optionEnum.ROYAL"> </p>
            </div>
            <div id="no-more-tables-load">
                <div infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300" (scrolled)="onScroll()">

                    <app-main-result-layout *ngIf="companyService.getOptionHeaderStyle()!==optionEnum.ROYAL" [totalCruises]="totalCruises" [colorCabecera]="colorCabecera" [colorSecundario]="colorSecundario" [logoCruise]="logoCruise" [empresa]="empresa" [isCharterOnly]="isCharterOnly"
                        [datesCompany]="datesCompany" [passengers]="passengers" [dataCodeEncrypt]="dataCodeEncrypt" [textAlart]="textAlart"></app-main-result-layout>
                    <app-secundary-result-layout *ngIf="companyService.getOptionHeaderStyle()===optionEnum.ROYAL" [totalCruises]="totalCruises" [colorCabecera]="colorCabecera" [colorSecundario]="colorSecundario" [logoCruise]="logoCruise" [empresa]="empresa" [isCharterOnly]="isCharterOnly"
                        [isPromoOnly]="isPromoOnly" [datesCompany]="datesCompany" [passengers]="passengers" [dataCodeEncrypt]="dataCodeEncrypt" [textAlart]="textAlart"></app-secundary-result-layout>

                </div>

            </div>
            <p class="desc">Showing {{ totalSearch }} tour options:</p>
            <!-- ===================================================================================== -->
            <!-- ========== MENSAJES QUE APARECEN CUANDO SE HACE SCROLL =========== -->
            <div class="spinner" *ngIf="cargarMas">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
            </div>
            <div *ngIf="searchStatus === searchStatusEnum.NO_MORE_RESULTS" class="avail-note textoResultado" style="color: black">
                There are no more cruises to show
            </div>
            <div class="avail-note" *ngIf="datesCompany && datesCompany.endSlideMessage" [innerHTML]="datesCompany.endSlideMessage">
            </div>
            <p>&nbsp;</p>
        </div>
        <div *ngIf="searchStatus === searchStatusEnum.NO_RESULTS" class="avail-note textoResultado" style="color: black">
            No results for this departure, please choose another date
        </div>
    </div>
</div>
<!-- FIN BODY CONTENEDOR -->
<div id="footer" class="">
    <!-- FOOTER CONTENEDOR -->
    <!-- BARRA BUSQUEDA PIE CONTENEDOR -->
    <app-search id="searchFooter" *ngIf="datesCompany" [childExample]="datesCompany.code" [dataCompany]="datesCompany" [listYearMonth]="this.datesCompany.listYearMonth" [colorMain]="datesCompany.mainColor" (valuesChange)="recibirDatos($event)" [listYearMonth]="datesCompany.listYearMonth"
        [catalogueItinerary]="datesCompany.listDays" [cataloguePax]="datesCompany.listPassenger" [colorSecundario]="colorSecundario" (resetValueContentResult)="ocultarContendorResultados($event)" [isSearching]="isSearching" (resetShowLoading)="showLoading($event)">
    </app-search>
    <!-- FIN BARRA BUSQUEDA PIE CONTENEDOR -->
    <!--<div class="container" style="background-color: #fff">-->

    <div class="container" *ngIf="this.datesCompany!=undefined " style="display: block" [ngStyle]="{ 'background-color': colorPie }">
        <!-- end main -->
        <!-- start post footer -->
        <div class="post-footer">
            <div class="wrap2 row-powered-by-container" id="powered-footer">

                <p style="color: #ececec;" [ngClass]="isTooDark(colorPie) ? 'darkMode' : 'lightMode'">Copyright {{ todayDate }} ©
                    <a href="https://galavail.com/" target="_blank" [ngClass]="isTooDark(colorPie) ? 'darkMode' : 'lightMode'">Galavail.com</a> &nbsp;All Rights Reserved. &nbsp;&bull;&nbsp;

                    <a [ngClass]="isTooDark(colorPie) ? 'darkMode' : 'lightMode'" [href]="mailTo">{{ datesCompany != undefined ?
            datesCompany.infoEmail : '' }}</a>
                </p>
                <img src="assets/images/powered-by-galavail.svg" alt="powered-by" style="margin-bottom: 15px;" />
            </div>
        </div>
        <!-- end post footer -->
    </div>
    <!-- FIN FOOTER CONTENEDOR -->
</div>
<app-whatsapp-button [whatsappNumber]="this.whatsappNumber"></app-whatsapp-button>